<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? '新增' : '删除'" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
            <el-form-item prop="name" label="机构名称">
                <el-input v-model="dataForm.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="lxr" label="机构联系人">
                <el-input v-model="dataForm.lxr" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="mobile" label="机构电话">
                <el-input v-model="dataForm.mobile" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="type" label="机构性质">
                <el-select v-model="dataForm.type" placeholder="请选择机构性质：">
                    <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="description" label="机构介绍">
                <el-input type="textarea"
                          :rows="4" v-model="dataForm.description" placeholder="请输入"></el-input>

            </el-form-item>
            <el-form-item prop="logo" label="机构LOGO">
                <uploadImage :imageUrl="dataForm.logo" @upSuc="dataForm.logo = $event"></uploadImage>
            </el-form-item>
            <el-form-item prop="license" label="营业执照">
                <uploadImage :imageUrl="dataForm.license" @upSuc="dataForm.license = $event"></uploadImage>
            </el-form-item>
            <el-form-item prop="userName" label="账号">
                <el-input v-model="dataForm.userName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码">
                <el-input v-model="dataForm.password" placeholder="请输入"></el-input>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'
    import uploadImage from "../../../components/uploadImage";
    export default {
        components: { uploadImage },
        data () {
            return {
                visible: false,
                dataForm: {
                    id: null,
                    "name": "",
                    "mobile": "",
                    "lxr": "",
                    "type": 1,
                    "userName": "",
                    "password": "",
                    "logo": "",
                    "description": "",
                    "license": ""
                },
                typeList: [
                    { label: '企业', value: 1},
                    { label: '事业单位', value: 2},
                    { label: '政府机关', value: 3},
                ]
            }
        },
        computed: {
            dataRule () {
                return {
                    name: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ],
                    lxr: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ],
                    type: [
                        { required: true, message: '请选择', trigger: 'blur' }
                    ],
                    logo: [
                        { required: true, message: '请上传', trigger: 'blur' }
                    ],
                    userName: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            init () {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            },
            // 获取信息
            getInfo () {
                this.$http.get(`/account/info/${this.dataForm.id}`).then(({ data: res }) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = res.position
                    this.dataForm.password = ''
                }).catch(() => {})
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http.post(
                        this.dataForm.id ? '/account/update' : '/account/save',
                        this.dataForm,
                    ).then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {})
                })
            }, 1000, { 'leading': true, 'trailing': false })
        }
    }
</script>
